import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import AdminHeader from "../components/Layout/AdminHeader";
import AdminSideBar from "../components/Admin/Layout/AdminSideBar";
import AdminThemeManagement from "../components/Admin/AdminThemeManagement";
import AdminVisualDesignLibrary from "../components/Admin/AdminVisualDesignLibrary";

const AdminDashboardTheme = () => {
  const [searchParams] = useSearchParams();
  const activeView = searchParams.get("view") === "ux-library" ? "ux-library" : "theme";

  return (
    <div className="admin-dashboard-container">
      <AdminHeader />
      <div className="admin-dashboard-content">
        <div className="admin-dashboard-wrapper">
          <div className="admin-dashboard-sidebar">
            <AdminSideBar active={activeView === "ux-library" ? 14 : 13} />
          </div>
          <div className="admin-dashboard-main admin-page-shell">
            <nav className="admin-theme-settings-tabs" aria-label="Admin theme settings sections">
              <Link
                to="/admin/theme"
                className={`admin-theme-settings-tab ${activeView === "theme" ? "admin-theme-settings-tab--active" : ""}`}
              >
                Theme Manager
              </Link>
              <Link
                to="/admin/theme?view=ux-library"
                className={`admin-theme-settings-tab ${activeView === "ux-library" ? "admin-theme-settings-tab--active" : ""}`}
              >
                UX Library
              </Link>
            </nav>
            {activeView === "ux-library" ? (
              <AdminVisualDesignLibrary />
            ) : (
              <>
                <header className="admin-page-hero">
                  <div>
                    <p className="admin-page-eyebrow">Live White Label Theme</p>
                    <h1>Theme Manager</h1>
                    <p className="admin-page-copy">Manage production theme tokens, logo assets, and white label visual settings.</p>
                  </div>
                </header>
                <AdminThemeManagement />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardTheme;
